module.exports = __webpack_public_path__ + "img/cart_vue.67e142d5.jpg";